
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import DefaultLayout from '@/components/DefaultLayout.vue';
import AdminService from '@/services/admin-service';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { Confirm } from '@/helpers/AuthHelper';
@Component({
  components: { DefaultLayout }
})
export default class AmazonTransReport extends Vue {
  $refs!: {
    DefaultActions: HTMLFormElement;
  };
  /* Properties */
  endDate: string = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .substr(0, 10);
  /* Store Actions */
  /* Watchers */
  /* Data */
  /* Computed */
  /* Async Functions */
  async sendConfirmationReport() {
    try {
      await AdminService.sendAmazonTspReport(this.endDate);
      SetSnackBar('Your report has been sent.');
    } catch (error) {
      SetSnackBar('The report failed.  Hold your head in shame.');
    }
  }
  /* Utility Functions */
  openDialog() {
    Confirm(
      () => {
        this.sendConfirmationReport();
      },
      'Confirm sending the report',
      'Are you sure you want to send this report?'
    );
  }
  /* Loaders */
  /* Mounted */
  /* Created */
  /* Emmited Functions */
}
